
import { Component, Prop, Vue } from 'vue-property-decorator'

import RadioItems from '@/components/forms/RadioItems.vue'
import RequiredAsterisk from '@/components/forms/RequiredAsterisk.vue'
import { randomIdentifier } from '@/helpers/StringHelpers'

@Component({
  name: 'RadioGroup',
  components: { RadioItems, RequiredAsterisk },
})
export default class extends Vue {
  @Prop({ required: true })
  options: RadioGroupOption[]

  @Prop()
  label: string

  // Initial value property.
  @Prop({ default: null })
  value: Primitive | null

  @Prop({ default: false })
  optional: boolean

  @Prop({ default: false })
  hideAsterisk: boolean

  @Prop()
  error: string

  @Prop()
  itemClassName: string

  @Prop()
  disabled: boolean

  @Prop()
  showMoreLabel: string

  errorInternal: string | null = null
  labelId: string = 'radio-group-label-' + randomIdentifier()

  created() {
    this.errorInternal = this.error || null
    if (this.options.length === 1 && !this.optional) {
      this.$emit('input', this.options[0].value)
    }
  }

  onInput(value) {
    this.$emit('input', value)
    this.validate()
  }

  validate() {
    const radioGroup = this.$refs.radioGroup as Vue
    const invalidField = radioGroup.$el.querySelector(':invalid') as HTMLInputElement
    this.errorInternal = invalidField ? invalidField.validationMessage : null
  }

  get showAsterisk() {
    return !this.optional && !this.hideAsterisk && !this.disabled
  }
}
